import React, { Component } from "react";
import NavDE from "../Symbols/NavDE";
import FooterDE from "../Symbols/FooterDE";
import "../../stylesheets/Kontakt.css";
import { Helmet } from "react-helmet-async";
import R1 from "../../assets/ref/ref_1.png";
import R2 from "../../assets/ref/ref_2.png";
import R3 from "../../assets/ref/ref_3.png";
import R4 from "../../assets/ref/ref_4.png";
import R5 from "../../assets/ref/ref_5.jpg";
import R6 from "../../assets/ref/ref_6.png";
import R7 from "../../assets/ref/ref_7.jpg";
import R8 from "../../assets/ref/ref_8.png";
import R9 from "../../assets/ref/ref_9.jpg";
import R10 from "../../assets/ref/ref_10.png";
import R11 from "../../assets/ref/ref_11.jpg";
import R12 from "../../assets/ref/ref_12.png";
import R13 from "../../assets/ref/ref_13.png";
import R14 from "../../assets/ref/ref_14.png";
import R15 from "../../assets/ref/ref_15.png";
import R16 from "../../assets/ref/ref_16.png";
import R17 from "../../assets/ref/ref_17.png";
import R18 from "../../assets/ref/ref_18.png";
import R19 from "../../assets/ref/ref_19.png";
import R20 from "../../assets/ref/ref_20.png";
import R21 from "../../assets/ref/ref_21.png";
import R22 from "../../assets/ref/ref_22.png";
import R23 from "../../assets/ref/ref_23.png";
import R24 from "../../assets/ref/ref_24.png";
import R25 from "../../assets/ref/ref_25.png";
import R26 from "../../assets/ref/ref_26.png";
import R27 from "../../assets/ref/ref_27.png";
import R28 from "../../assets/ref/ref_28.jpg";
import R29 from "../../assets/ref/ref_29.png";
import R30 from "../../assets/ref/ref_30.png";
import R31 from "../../assets/ref/ref_31.png";
import R32 from "../../assets/ref/ref_32.png";
import R33 from "../../assets/ref/ref_33.png";
import R34 from "../../assets/ref/ref_34.png";

class References extends Component {
  constructor(props) {
    super(props);
    this.intro = React.createRef();
  }

  introScroll = () => {
    let element = this.intro.current;
    let headerOffset = 45;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - Referenzen</title>
          <meta
            name="description"
            content="Entdecken Sie spannende Referenzen von Pancon – innovative
Lösungen, erfolgreich umgesetzte Projekte, zufriedene Kunden, Distributoren.
Lassen Sie sich von unserer Kompetenz und Erfahrung überzeugen!"
          />
          <meta property="og:title" content="Pancon - Referenzen" />
          <meta
            property="og:description"
            content="Entdecken Sie spannende Referenzen von Pancon – innovative
Lösungen, erfolgreich umgesetzte Projekte, zufriedene Kunden, Distributoren.
Lassen Sie sich von unserer Kompetenz und Erfahrung überzeugen!"
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/referenzen"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/references"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavDE />
        <div className="hero ref">
          <div className="red-bg-hero"></div>
          <div className="hero-content">
            <h1 className="hero-heading">Referenzen</h1>
            <p className="hero-desc">Unsere Partner</p>
            <button onClick={this.introScroll} className="default inverted">
              Mehr erfahren
            </button>
          </div>
        </div>
        <div
          ref={this.intro}
          className="section flex first intro center-h less-bot"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2>Referenzen</h2>
              <div className="flex center-v center-h ref">
                <img src={R1} className="flex ref center-h center-v"></img>
                <img src={R2} className="flex ref center-h center-v"></img>
                <img src={R3} className="flex ref center-h center-v"></img>
                <img src={R4} className="flex ref center-h center-v"></img>
              </div>
              <div className="flex center-v center-h ref">
                <img src={R5} className="flex ref center-h center-v"></img>
                <img src={R6} className="flex ref center-h center-v"></img>
                <img src={R7} className="flex ref center-h center-v"></img>
                <img src={R8} className="flex ref center-h center-v"></img>
              </div>
              <div className="flex center-v center-h ref">
                <img src={R9} className="flex ref center-h center-v"></img>
                <img src={R10} className="flex ref center-h center-v"></img>
                <img src={R11} className="flex ref center-h center-v"></img>
                <img src={R12} className="flex ref center-h center-v"></img>
              </div>
              <div className="flex center-v center-h ref start">
                <img src={R13} className="flex ref center-h center-v"></img>
                <img src={R14} className="flex ref center-h center-v"></img>
                <img src={R15} className="flex ref center-h center-v"></img>
                <img src={R16} className="flex ref center-h center-v"></img>
              </div>
              <div className="flex center-v center-h ref start">
                <img src={R17} className="flex ref center-h center-v"></img>
                <img src={R18} className="flex ref center-h center-v"></img>
                <img src={R19} className="flex ref center-h center-v"></img>
                <img src={R20} className="flex ref center-h center-v"></img>
              </div>
              <div className="flex center-v center-h ref start">
                <img src={R21} className="flex ref center-h center-v"></img>
                <img src={R22} className="flex ref center-h center-v"></img>
                <img src={R23} className="flex ref center-h center-v"></img>
                <img src={R24} className="flex ref center-h center-v"></img>
              </div>
              <div className="flex center-v center-h ref start">
                <img src={R25} className="flex ref center-h center-v"></img>
                <img src={R26} className="flex ref center-h center-v"></img>
                <img src={R27} className="flex ref center-h center-v"></img>
                <img src={R28} className="flex ref center-h center-v"></img>
              </div>
              <div className="flex center-v center-h ref start">
                <img src={R29} className="flex ref center-h center-v"></img>
                <img src={R30} className="flex ref center-h center-v"></img>
                <img src={R31} className="flex ref center-h center-v"></img>
                <img src={R32} className="flex ref center-h center-v"></img>
              </div>
              <div className="flex center-v center-h ref start">
                <img src={R33} className="flex ref center-h center-v"></img>
                <img src={R34} className="flex ref center-h center-v"></img>
              </div>
            </div>
          </div>
        </div>
        <FooterDE />
      </div>
    );
  }
}

export default References;
